import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export class Accordion {
	constructor() {
		this.accordions = document.querySelectorAll(".accordion");

		this.init();
		this.handleInitialURL();
	}

	init() {
		this.accordions.forEach((accordion) => {
			this.setupAccordion(accordion);
		});
	}

	setupAccordion(accordion) {
		const button = accordion.querySelector(".accordion__button");
		const content = accordion.querySelector(".accordion__content");
		const text = accordion.querySelector(".accordion__text");
		const arrow = accordion.querySelector(".accordion__arrow");

		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.inOut",
				duration: this.isReducedMotion() ? 0 : 0.5,
			},
			onStart: () => {
				button.setAttribute("aria-expanded", "true");
				content.setAttribute("aria-expanded", "true");
			},
			onUpdate: () => {
				ScrollTrigger.refresh();
			},
			onReverseComplete: () => {
				button.setAttribute("aria-expanded", "false");
				content.setAttribute("aria-expanded", "false");
			},
		});

		timeline
			.fromTo(
				content,
				{
					height: 0,
					autoAlpha: 0,
				},
				{
					height: "auto",
					autoAlpha: 1,
					immediateRender: false,
				},
				0
			)
			.from(
				text,
				{
					y: -5,
				},
				0
			)
			.to(
				arrow,
				{
					rotate: -180,
					ease: "back.inOut",
				},
				0
			);

		timeline.reverse();

		button.addEventListener("click", () => {
			const expanded = button.getAttribute("aria-expanded") === "true";

			if (!expanded) {
				timeline.play();
				this.updateURL(accordion.id);
			} else {
				timeline.reverse();
				this.clearURL();
			}
		});
	}

	isReducedMotion() {
		return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	}

	handleInitialURL() {
		const hash = window.location.hash.slice(1);
		if (hash) {
			try {
				const accordion = document.getElementById(hash);
				if (accordion?.classList.contains("accordion")) {
					const button = accordion.querySelector(".accordion__button");
					button?.dispatchEvent(new Event("click"));
					accordion.scrollIntoView({ behavior: "smooth" });
				}
			} catch (err) {
				console.error(err);
			}
		}
	}

	updateURL(accordionId) {
		window.history.replaceState(null, "", `#${accordionId}`);
	}

	clearURL() {
		const url = window.location.pathname + window.location.search;
		window.history.replaceState(null, "", url);
	}
}
